import * as React from 'react';
import { View, Image, StyleSheet } from 'react-native';

import testID from 'utils/test-id';

const IMAGE_SIZE_MAP = {
  '12': '12',
  '14': '14',
  '16': '16',
  '18': '18',
  '20': '20',
  '22': '22',
  '24': '24',
  '26': '26',
  '32': '32',
  '44': '44',
};

export type IconSize = keyof typeof IMAGE_SIZE_MAP;

// sort by alphabetical order
export const ICON_MAP = {
  'arrow-half-right': require('assets/images/icons/arrow-half-right.png'),
  'back-arrow': require('assets/images/icons/back-arrow.png'),
  beginner: require('assets/images/icons/beginner.png'),
  'caret-left': require('assets/images/icons/caret-left.png'),
  'caret-left-thin': require('assets/images/icons/caret-left-thin.png'),
  'caret-right': require('assets/images/icons/caret-right.png'),
  'caret-right-thin': require('assets/images/icons/caret-right-thin.png'),
  'caret-up': require('assets/images/icons/caret-up.png'),
  'caret-down': require('assets/images/icons/caret-down.png'),
  cart: require('assets/images/icons/cart.png'),
  cash: require('assets/images/icons/cash.png'),
  'cash-circle': require('assets/images/icons/cash-circle.png'),
  'circled-check': require('assets/images/icons/circled-check.png'),
  close: require('assets/images/icons/close.png'),
  cog: require('assets/images/icons/cog.png'),
  'new-cog': require('assets/images/icons/new-cog.png'),
  contact: require('assets/images/icons/contact.png'),
  email: require('assets/images/icons/email.png'),
  exit: require('assets/images/icons/exit.png'),
  help: require('assets/images/icons/question.png'),
  information: require('assets/images/icons/information.png'),
  inspiration: require('assets/images/icons/inspiration.png'),
  'lock-upgrade': require('assets/images/icons/lock-upgrade.png'),
  'magnify-glass': require('assets/images/icons/magnify-glass.png'),
  'magnify-glass-alt': require('assets/images/icons/magnify-glass-alt.png'),
  mobile: require('assets/images/icons/mobile.png'),
  'new-pill': require('assets/images/icons/new-pill.png'),
  payment: require('assets/images/icons/payment.png'),
  shop: require('assets/images/icons/shop.png'),
  'shop-white': require('assets/images/icons/shop-white.png'),
  'statement-next': require('assets/images/icons/statement-nav-next.png'),
  'statement-previous': require('assets/images/icons/statement-nav-previous.png'),
  tick: require('assets/images/icons/tick.png'),
  times: require('assets/images/icons/times.png'),
  'times-alt': require('assets/images/icons/times-alt.png'),
  user: require('assets/images/icons/user.png'),
  favorite: require('assets/images/icons/favorite.png'),
  'favorite-alt': require('assets/images/icons/favorite-alt.png'),
  'favorite-border': require('assets/images/icons/favorite-border.png'),
  'favorite-thin-border': require('assets/images/icons/favorite-thin-border.png'),
  'favorite-border-alt': require('assets/images/icons/favorite-border-alt.png'),
  refresh: require('assets/images/icons/refresh.png'),
  'refresh-alt': require('assets/images/icons/refresh-alt.png'),
  'refresh-alt-thin': require('assets/images/icons/refresh-alt-thin.png'),
  star: require('assets/images/icons/star.png'),
  plus: require('assets/images/icons/plus-logo.png'),
  account: require('assets/images/icons/account.png'),
  'multi-pay-contract': require('assets/images/icons/multi-pay-contract.png'),
  previous: require('assets/images/icons/previous.png'),
  next: require('assets/images/icons/next.png'),
  gear: require('assets/images/icons/gear.png'),
  captured: require('assets/images/charge-kind/authorized.png'),
  refund: require('assets/images/charge-kind/refund.png'),
  'late-fee': require('assets/images/charge-kind/late-fee.png'),
  cashback: require('assets/images/charge-kind/cashback.png'),
  settlement: require('assets/images/charge-kind/settlement.png'),
  'multi-pay': require('assets/images/charge-kind/multi-pay.png'),
  'exclamation-mark': require('assets/images/icons/exclamation-mark.png'),
  'exclamation-mark-alt': require('assets/images/icons/icon-exclamation.png'),
  linking: require('assets/images/icons/linking.png'),
  'checked-shield': require('assets/images/icons/checked-shield.png'),
  secure: require('assets/images/icons/secure.png'),
  'arrow-backward': require('assets/images/icons/arrow-backward.png'),
  'arrow-forward': require('assets/images/icons/arrow-forward.png'),
  'bold-times': require('assets/images/icons/bold-times.png'),
  home: require('assets/images/icons/home.png'),
  'paidy-plus-logo': require('assets/images/icons/paidy-plus-logo.png'),
  eye: require('assets/images/icons/eye.png'),
  'eye-thin': require('assets/images/icons/eye-thin.png'),
  'eye-invisible': require('assets/images/icons/eye-invisible.png'),
  'eye-invisible-thin': require('assets/images/icons/eye-invisible-thin.png'),
  copy: require('assets/images/icons/copy.png'),
  settings: require('assets/images/icons/settings.png'),
  search: require('assets/images/icons/search.png'),
  'search-thin': require('assets/images/icons/search-thin.png'),
  'favorite-disabled': require('assets/images/icons/favorite-disabled.png'),
  lock: require('assets/images/icons/lock.png'),
  'plus-gray': require('assets/images/icons/plus-gray.png'),
  'delete-icon': require('assets/images/icons/delete-icon.png'),
  'horizontal-menu': require('assets/images/icons/horizontal-menu.png'),
  card: require('assets/images/icons/card.png'),
  'card-line': require('assets/images/icons/card-line.png'),
  'card-line-howto': require('assets/images/icons/card-line-howto.png'),
  'card-pink': require('assets/images/icons/card-pink.png'),
  'home-line': require('assets/images/icons/home-line.png'),
  'statement-line': require('assets/images/icons/statement-line.png'),
  'shop-line': require('assets/images/icons/shop-line.png'),
  'shopping-bag-black': require('assets/images/icons/shopping-bag-black.png'),
  'shopping-bag-dark': require('assets/images/icons/shopping-bag-dark.png'),
  'account-line': require('assets/images/icons/account-line.png'),
  'home-pink': require('assets/images/icons/home-pink.png'),
  'statement-pink': require('assets/images/icons/statement-pink.png'),
  'shop-pink': require('assets/images/icons/shop-pink.png'),
  'account-pink': require('assets/images/icons/account-pink.png'),
  funnel: require('assets/images/icons/funnel.png'),
  'link-chevron': require('assets/images/icons/link-chevron.png'),
  'blue-checkmark': require('assets/images/icons/blue-checkmark.png'),
  'help-sms': require('assets/images/icons/question-sms.png'),
  'bullet-black': require('assets/images/icons/bullet-black.png'),
  'home-indicator': require('assets/images/icons/home-indicator.png'),
  calendar: require('assets/images/icons/calendar.png'),
  bulb: require('assets/images/icons/bulb.png'),
  'budget-tre': require('assets/images/icons/budget-tre.png'),
  npay: require('assets/images/icons/npay.png'),
  // TODO here are the new design system components. Old ones(email, mobile) can be replaced with them after Login/Resetphonescreen design renewal.
  'email-new': require('assets/images/icons/email-new.png'),
  'mobile-new': require('assets/images/icons/mobile-new.png'),
  'thumbs-up': require('assets/images/icons/thumbs-up.png'),
  'thumbs-down': require('assets/images/icons/thumbs-down.png'),
  shield: require('assets/images/icons/shield.png'),
  'bulb-dark': require('assets/images/icons/bulb-dark.png'),
};

export type IconName = keyof typeof ICON_MAP;

export default function Icon({
  name,
  size,
  tintColor,
  style,
  variant,
}: {
  name: IconName;
  size: IconSize;
  tintColor?: string;
  style?: ViewStyleProp;
  variant?: string;
}) {
  const sizeStr = ('' + size) as IconSize;
  const imageSizeStr = variant === 'full' ? sizeStr : IMAGE_SIZE_MAP[sizeStr];

  return (
    <View style={[styles.container, styles[`size-${sizeStr}`], style]}>
      <Image
        style={[
          styles.image,
          styles[`size-${imageSizeStr}`],
          !!tintColor && { tintColor },
        ]}
        source={ICON_MAP[name]}
        {...testID(`icon-name-${name}`)}
      />
    </View>
  );
}

const styles: {
  [key: string]: ImageStyleProp;
} = StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  image: {
    resizeMode: 'contain',
  },
  /* eslint-disable react-native/no-unused-styles */
  ['size-12']: {
    width: 12,
    height: 12,
  },
  ['size-14']: {
    width: 14,
    height: 14,
  },
  ['size-16']: {
    width: 16,
    height: 16,
  },
  ['size-18']: {
    width: 18,
    height: 18,
  },
  ['size-20']: {
    width: 20,
    height: 20,
  },
  ['size-22']: {
    width: 22,
    height: 22,
  },
  ['size-24']: {
    width: 24,
    height: 24,
  },
  ['size-26']: {
    width: 26,
    height: 26,
  },
  ['size-32']: {
    width: 32,
    height: 32,
  },
  ['size-44']: {
    width: 44,
    height: 44,
  },
  /* eslint-enable react-native/no-unused-styles */
});
